<template>
  <div id="app">
    <vue-confirm-dialog></vue-confirm-dialog>
    <router-view/>
  </div>
</template>
<script>
//import HelloWorld from './components/HelloWorld.vue'
// Get a RTDB instance



export default {
  name: 'App',
  components: {
   // HelloWorld,
  },
  data() {
    return {
      jobsRaw: [],
      limit:50,
    }
  },
computed: {

},

  methods: {
   
  },
  created(){
      const appLoader = document.getElementById('loading-bg');
      if (appLoader) {
        appLoader.style.display = 'none';
      }
  }
}
</script>
<style lang="scss">
#app {

}
</style>
